import { AmountInfo, InfoStatsModel, InfoType } from '@/entities/referral'
import { BalanceChangeBadge, InformationStatisticCards } from '@/shared/components'
import { getPercentChange } from '@/shared/components/BalanceChangeBadge/lib'
import { StatisticTabNames } from '@/shared/lib/models/tabsStatisticOptions'

type Props = {
  data: InfoType
  currentBalance: number
  currentBalanceFrom: number
  yesterdayBalance: number
  type: StatisticTabNames
  showRateInfo?: boolean
  showBalanceChange?: boolean
}

export const StatisticRefPanel = ({ data, currentBalance, currentBalanceFrom, yesterdayBalance, type, showRateInfo, showBalanceChange = true }: Props) => {
  const { averageTime, conversion, orders, profit } = data

  const infoCards: InfoStatsModel[] = [
    { id: 1, key: type === 'payIn' ? 'Входящие сделки' : 'Исходящие заявки', value: orders },
    { id: 2, key: 'Личная прибыль', value: profit },
    { id: 5, key: 'Конверсия', value: conversion },
    { id: 6, key: 'Среднее время обработки ордера', value: Math.round(averageTime) },
  ]
  const percentChange = getPercentChange(yesterdayBalance, currentBalance)

  return (
    <div>
      <div className="mb-[10px] md:mb-4">
        {showBalanceChange && percentChange !== 0 && (
          <BalanceChangeBadge currentBalance={currentBalance} yesterdayBalance={yesterdayBalance} />
        )}
      </div>

      <AmountInfo currentBalance={currentBalance} currentBalanceFrom={currentBalanceFrom} className="mb-6 md:mb-[40px]" type={type} showRateInfo={showRateInfo} />
      <InformationStatisticCards infoCards={infoCards} />
    </div>
  )
}
